import React from "react";

import { Typography } from "@material-ui/core";
import Slider from "@material-ui/core/Slider";

import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IEditorState, EditorMode, setSpacing } from "../../redux";

interface ISpacingProps {
    spacing: number;
    labelOpacity: number;
    isDisabled: boolean;
    style?: React.CSSProperties;

    setSpacing: (_: any, spacing: number) => void;
}

class SpacingWidget extends React.Component<ISpacingProps> {
    public render() {
        const {
            spacing,
            labelOpacity,
            isDisabled,
            setSpacing,
            style,
        } = this.props;

        const handleChange = (_, v) => setSpacing(_, v as number);

        return (
            <div style={style}>
                <Typography style={{opacity: labelOpacity}}>Spacing</Typography>
                <Slider
                    disabled={isDisabled}
                    style={{width: 300, paddingTop: 0, paddingBottom: 0}}
                    value={spacing}
                    min={0}
                    max={50}
                    step={5}
                    onChange={handleChange}
                />
            </div>
        );
    }
}

const stateToProps = (state: IEditorState) => {
    const isEditing = state.mode === EditorMode.Edit;

    return {
        spacing: state.spacing,
        labelOpacity: isEditing ? 1.0 : 0.6,
        isDisabled: !isEditing
    };
};

const dispatchToProps = (dispatch) => ({
    setSpacing: (_: any, spacing: number) => dispatch(setSpacing(spacing))
})

export const EditorSpacingWidget = connect(stateToProps, dispatchToProps)(SpacingWidget);